import { useEffect, useMemo, useRef, useState } from 'react'
import { useAuth } from '../../contexts/AuthContext'
import GoogleSignInButton from './GoogleSignInButton'

const DESKTOP_PROTOCOL = 'vatli365-recorder://auth'

function isDesktopAuthRequest(): boolean {
  const params = new URLSearchParams(window.location.search)
  return params.get('desktopAuth') === '1' || params.get('desktop_auth') === '1'
}

function getStoredToken(): string {
  return localStorage.getItem('auth_token') || localStorage.getItem('jwt_token') || ''
}

function getStoredJson(key: string, fallback: unknown): string {
  const stored = localStorage.getItem(key)
  if (stored) return stored
  return JSON.stringify(fallback)
}

export default function DesktopAuthBridge() {
  const { user, profile, isAuthenticated, isLoading } = useAuth()
  const attemptedRef = useRef(false)
  const desktopAuth = useMemo(isDesktopAuthRequest, [])
  const [returning, setReturning] = useState(false)

  useEffect(() => {
    if (!desktopAuth || attemptedRef.current || isLoading || !isAuthenticated || !user) return

    const token = getStoredToken()
    if (!token) return

    attemptedRef.current = true
    setReturning(true)

    const callbackUrl = new URL(DESKTOP_PROTOCOL)
    callbackUrl.searchParams.set('token', token)
    callbackUrl.searchParams.set('user', getStoredJson('auth_user', user))
    if (profile) {
      callbackUrl.searchParams.set('profile', getStoredJson('user_profile', profile))
    }
    callbackUrl.searchParams.set('redirect', '/')

    window.location.href = callbackUrl.toString()
  }, [desktopAuth, isAuthenticated, isLoading, profile, user])

  if (!desktopAuth) return null

  if (!returning && !isLoading && !isAuthenticated) {
    return (
      <div className="fixed inset-x-0 top-4 z-[9999] mx-auto max-w-lg rounded-xl border border-blue-200 bg-white px-5 py-4 text-center shadow-lg">
        <p className="font-semibold text-blue-700">Dang nhap Ebook Vatli365 Desktop</p>
        <p className="mb-3 mt-1 text-sm text-slate-600">
          Dang nhap bang Chrome, sau do he thong se tu quay lai ung dung tren may tinh.
        </p>
        <div className="flex justify-center">
          <GoogleSignInButton />
        </div>
      </div>
    )
  }

  if (!returning) return null

  return (
    <div className="fixed inset-x-0 top-4 z-[9999] mx-auto max-w-lg rounded-xl border border-emerald-200 bg-white px-5 py-4 text-center shadow-lg">
      <p className="font-semibold text-emerald-700">Dang nhap thanh cong</p>
      <p className="mt-1 text-sm text-slate-600">Dang quay lai ung dung Ebook Vatli365 tren may tinh...</p>
    </div>
  )
}
